// src/components/features/WelcomeBanner.tsx
import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'nla_welcome_dismissed';

interface Props {
  balance: number;
  onDismiss?: () => void;
}

export function WelcomeBanner({ balance, onDismiss }: Props) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (!dismissed) setVisible(true);
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
    onDismiss?.();
  };

  if (!visible) return null;

  return (
    <div className="mx-4 mb-4 rounded-xl border border-amber-300 bg-gradient-to-r from-amber-50 to-yellow-50 p-4 shadow-sm">
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xl">⚖️</span>
            <h3 className="font-semibold text-amber-900 text-sm">Welcome to notlegal.chat!</h3>
          </div>
          <p className="text-xs text-amber-800 leading-relaxed">
            You have <strong>{balance} free tokens</strong> to get started. Ask any legal question —
            we'll give you general information (not legal advice, obviously 😄).
          </p>
          <div className="flex gap-4 mt-2 text-xs text-amber-700">
            <span>💬 ~50 tokens per message</span>
            <span>📄 ~300 tokens per document</span>
            <span>🔍 ~500 tokens per contract review</span>
          </div>
        </div>
        <button
          onClick={handleDismiss}
          className="text-amber-400 hover:text-amber-600 text-xl leading-none flex-shrink-0"
          aria-label="Dismiss"
        >
          ×
        </button>
      </div>
      <button
        onClick={handleDismiss}
        className="mt-3 text-xs bg-amber-600 text-white rounded-lg px-3 py-1.5 hover:bg-amber-700 transition-colors"
      >
        Got it, let's ask a legal question →
      </button>
    </div>
  );
}
